<template>
  <div
    v-if="show"
    :class="`arrow-nav-${this.type}`"
    class="arrow-nav"
    @click="onClick"
  >
    <i
      :class="`fa-chevron-${this.type}`"
      class="fa"
    ></i>
    <span class="label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "ArrowNav",

  props: {
    show: {
      type: Boolean,
      required: false,
      default: true,
    },
    type: {
      type: String,
      required: false,
      default: "right",
    },
  },

  computed: {
    label() {
      if (this.type === "right") return this.$t("articles.next");

      return this.$t("articles.previous");
    },
  },

  methods: {
    onClick: function () {
      this.$emit("on-click");
    },
  },
};
</script>

<style lang="scss" scoped>
$margin-icon: 5px;
$time-play: 0.7s;
$time-back: 0.4s;
$shadow: 0px 5px 0px rgba(0, 0, 0, 0.5);

.arrow-nav {
  background: rgba(0, 0, 0, 1);
  opacity: 0.5;
  position: absolute;
  bottom: 45%;
  height: 42px;
  width: 20px;
  font-size: 0.8rem;
  line-height: 42px;
  text-align: center;
  color: white;
  cursor: pointer;
  z-index: 777;
  transition: all $time-back;
  overflow: hidden;
  align-items: center;

  &.arrow-nav-right {
    right: 0px;
    width: 20px;
    text-align: left;
    padding-left: 7px;
    display: flex;

    .label {
      order: 1;
      margin-right: 5px;
    }

    i {
      order: 2;
      margin-right: $margin-icon;
    }
  }

  &.arrow-nav-left {
    left: -50px;
    width: 70px;
    text-align: right;
    padding-right: 7px;
  }

  .label {
    display: none;
    transition: all $time-back;
  }

  i {
    transition: all $time-back;
  }

  &:hover {
    opacity: 0.9;
    transition: all $time-play;

    &.arrow-nav-left {
      left: 0px;
      transition: all $time-play;
      -webkit-box-shadow: 3px $shadow;
      -moz-box-shadow: 3px $shadow;
      box-shadow: 3px $shadow;

      i {
        margin-right: $margin-icon;
      }
    }

    &.arrow-nav-right {
      width: 55px;
      transition: all $time-play;
      -webkit-box-shadow: -3px $shadow;
      -moz-box-shadow: -3px $shadow;
      box-shadow: -3px $shadow;

      i {
        margin-right: $margin-icon;
      }
    }

    .label {
      display: inline;
    }
  }
}
</style>